import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconService from "../services/aircon.service";
import { Airconvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import authsService from "../services/auths.service";
import Airconhistoryy from "./Airconhistoryy";
import Airconunity from "./Airconunity";
import airconhistoryService from "../services/airconhistory.service";
import Googlecharts from "../components/Googlecharts";

const Airconview = (props) => {
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();

  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const ref = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");
  const [aircondetail, setAircondetail] = useState("");
  const [totalexpense, setTotalexpense] = useState(0);

  const [aircon_id, setAirconid] = useState();
  const [selected, setSelected] = useState("history");
  const [selectedarr, setSelectedarr] = useState([
    { label: "History", value: "history" },
    { label: "Units", value: "airconunit" },
    { label: "Expense", value: "expensechart" },
  ]);
  //form initial value

  //use effects
  useEffect(() => {
    setAirconid(searchParams.get("aircon_id"));
    if (searchParams.get("aircon_id")) {
      setEventname("view");
      getAircon(searchParams.get("aircon_id"));
      getallAirconhistory()
    } else {
      setEventname("create");
    }
    /*     getallAirconhistory(); */
  }, []);

  //get aircon
  const getAircon = (value) => {
    setIsLoaded(true);
    airconService
      .getAircon(value)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          let data = res.data.result;
          setAircondetail(data);
          if (Array.isArray(data)) {
            console.log('gello', data);
            setAircondetail("");
          }

        } else {
          setIsLoaded(false);
          setAircondetail("");
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  const [airconexpensearr, setAirconexpensearr] = useState("");
  //get allairconhistory
  const getallAirconhistory = () => {
    setIsLoaded(true);
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      filterclient: "",
      filteraircon: searchParams.get("aircon_id"),
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    airconhistoryService
      .getallAirconhistory(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          const data = [
            ["type", "expense($)"],
            ["0", 0],
            ...res.data.result.data.map((d) => [
              d.ah_type + "(" + d.createdAt + ")",
              Number(d.total_amount),
            ]),
          ];
          console.log(data);
          setAirconexpensearr(data);
          const sum = res.data.result.data.reduce((accumulator, object) => {
            return accumulator + Number(object.total_amount);
          }, 0);
          setTotalexpense(sum)
          console.log(sum);
        } else {
        }
      })
      .catch((err) => { });
  };
  const selectedfn = (value) => {
    setSelected(value);
  };
  // Call aircon clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="">
        {/*  container */}
        {aircondetail ? <>
          <div>
            <div className="bg-white rounded shadow-sm pb-0 p-1">
              <div className="fw-bold pt-2 pb-2">Aircon Details</div>
              <table className="table bg-white table-striped">
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{aircondetail?.aircon_id}</td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td>{aircondetail?.aircon_type}</td>
                  </tr>
                  <tr>
                    <td>Location</td>
                    <td>
                      {aircondetail?.aircon_block},{aircondetail?.aircon_level},
                      {aircondetail?.aircon_location}
                    </td>
                  </tr>
                  <tr>
                    <td>Total unit</td>
                    <td>{aircondetail?.total_unit}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>{aircondetail?.aircon_status}</td>
                  </tr>
                  <tr>
                    <td>Created date</td>
                    <td>{aircondetail?.createdAt}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/*  loader and error handler */}
            {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
            {/* <Toastmessage ref={ref} /> */}
            {/* <Alertmsg ref={ref}/> */}
          </div>
          {/* servicing history add */}
          <div
            className={
              searchParams.get("aircon_id") == null ? "d-none" : "d-black"
            }
          >
            <div className="d-flex flex-wrap mb-3 mt-3 shadow-sm bg-white rounded p-1">
              {/* <a className="btn btn-secondary rounded-0">
            <i className="fa fa-cogs"></i>
          </a> */}
              {selectedarr.map((selectedarrs, index) => (
                <button
                  onClick={() => selectedfn(selectedarrs.value)}
                  key={index}
                  className={
                    selected === selectedarrs.value
                      ? "btn  btn-primary  "
                      : "btn  "
                  }
                >
                  {selectedarrs.label}
                </button>
              ))}
            </div>
            {/* section tab page */}
            <div className="">
              {selected === "history" ? (
                <Airconhistoryy
                  aircon_id={aircondetail?.aircon_id}
                  client_id={aircondetail?.client_id}
                />
              ) : selected === "airconunit" ? (
                <Airconunity
                  aircon_id={aircondetail?.aircon_id}
                  client_id={aircondetail?.client_id}
                />
              ) : selected === "expensechart" ? (
                <div className="bg-white">
                  <div className="p-2 ">Total Expenses <strong>${totalexpense}</strong></div>
                  {airconexpensearr && <Googlecharts
                    com_data={airconexpensearr}
                    chart_type="AreaChart"
                    haxis="type"
                    vaxis="aircon expenses"
                  />}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </> : <>
          <div className="text-center">Scanned Qrcode details not found
            <p>{userinfos.login_type === "client" ? <></> : <><button onClick={() => navigate("/airconevent?aircon_ids=" + searchParams.get("aircon_ids"))} className="btn btn-primary mt-3"><i className="fa fa-plus"></i> Add Aircon</button></>}</p>

          </div>
        </>}
      </div>
    );
  }
};

export default Airconview;
